// src/components/Archieve/index.js
import React, { useMemo } from "react";
import { Timeline, Typography, Space, Tag, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

export default function Archieve({ posts }) {
  const navigate = useNavigate();

  const groups = useMemo(() => {
    const map = new Map();
    posts.forEach((p) => {
      const key = dayjs(p.createdAt).format("YYYY-MM");
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(p);
    });
    return Array.from(map.entries()).sort((a, b) => (a[0] < b[0] ? 1 : -1));
  }, [posts]);

  if (!posts?.length) return <Empty description="暂无文章" />;

  return (
    <div>
      {groups.map(([ym, list]) => (
        <div key={ym} style={{ marginBottom: 20 }}>
          <Typography.Title
            level={4}
            style={{ marginBottom: 12, color: "var(--text-primary)" }}
          >
            {ym}
          </Typography.Title>

          <Timeline
            items={list
              .sort((a, b) => b.createdAt - a.createdAt)
              .map((p) => ({
                children: (
                  <Space direction="vertical" size={2}>
                    <Typography.Link
                      onClick={() => navigate(`/post/${p.id}`)}
                      style={{ color: "var(--text-primary)" }}
                    >
                      {p.title}
                    </Typography.Link>
                    <Space wrap size={6}>
                      <Typography.Text
                        type="secondary"
                        style={{ fontSize: 12, color: "var(--text-secondary)" }}
                      >
                        {dayjs(p.createdAt).format("MM-DD HH:mm")}
                      </Typography.Text>
                      {(p.tags || []).slice(0, 3).map((t) => (
                        <Tag key={t} className="themed-tag">
                          {t}
                        </Tag>
                      ))}
                    </Space>
                  </Space>
                ),
              }))}
          />
        </div>
      ))}
    </div>
  );
}
